import React, { useState } from 'react';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../config/firebase';
import { useNavigate } from 'react-router-dom';
import '../styles/ForgotPassword.css'; 

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [feedback, setFeedback] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFeedback('');
    if (!email) {
      setFeedback('Please enter a valid email address.');
      return;
    }
    try {
      await sendPasswordResetEmail(auth, email);
      setFeedback(`A password reset link has been sent to ${email}. Please check your inbox.`);
    } catch (error) {
      setFeedback(error.message);
    }
  };

  const handleCancel = () => {
    navigate('/signin'); // Navigate back to sign in or another page as needed
  };

  return (
    <div className="forgot-password-body">
      <div className="forgot-password-container">
        <div className="forgot-password-form">
          <h1>Reset Your Password</h1>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="email"
                placeholder="Enter email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <button type="submit" className="submit-button">Send Reset Link</button>
            <button type="button" className="cancel-button" onClick={handleCancel}>Cancel</button>
          </form>
          {feedback && <p className="error-message">{feedback}</p>}
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;